import type { GridProps } from '@mui/material'
import { Grid, Paper } from '@mui/material'
import type { FC } from 'react'

const PaperedGridItem: FC<GridProps> = ({ children, ...props }) => (
  <Grid item {...props}>
    <Paper sx={{ padding: '20px' }}>{children}</Paper>
  </Grid>
)

export default PaperedGridItem
